import { render } from "./Eiken.vue?vue&type=template&id=616a004a&ts=true"
import script from "./Eiken.vue?vue&type=script&lang=ts"
export * from "./Eiken.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__